import { DataBean } from "../DataBean";

export class IndirectCostType extends DataBean {

    public async getIndirectCostTypeCatalog(idIndirectCostType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIndirectCostTypeCatalog_Number", [idIndirectCostType]);
    }
  public async getIndirectCostTypeCatalogvdos(idIndirectCostType: number,type:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getIndirectCostTypeCatalog_Number_Number_String_Number_Number", [idIndirectCostType,type,regexStr,page,recordsPerPage]);
    }
}
